/*
* @Author: Alexander.Vangelov@vonage.com
* @Date: 2020-07-01 16:00:38
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2024-03-21 22:18:54
*/

import { share }  from './c2d/share';

import { core, IContactableRef, IDialerConfig, IEntityRef } from './core';
import { DialerApi } from './api';
import { DialerUI } from './ui';

let dialerUI;

let config: any = {
  provider: 'uc'
};
(window as any).config = config;

const reloadPlayground = () => {
  let path = `${location.pathname}?provider=${config.provider}`;
  if (config.integration) {
    path += `&integration=${config.integration}`;
  }
  location.assign(path);
}

const loadSDKLibrary = (bundle) => {
  return new Promise(resolve => {
    const scriptElement = document.createElement('script');
    scriptElement.src = `${bundle}.js`;
    scriptElement.onload = resolve;
    scriptElement.onerror = (e) => {
      console.error(`Error loading ${bundle}`, e);
    };
    document.head.append(scriptElement);
  });
}

const integrationMatch = location.search.match(/[\?\&]integration=(\w+)/);
if (integrationMatch) {
  config.integration = integrationMatch[1];
  loadSDKLibrary(`vonage.dialer.cti.${integrationMatch[1]}`);
  document.addEventListener('DOMContentLoaded', () => {
    const playgroundIntegration = document.getElementById(`i_${integrationMatch[1]}`);
    if (playgroundIntegration) {
      playgroundIntegration.setAttribute('checked', 'true');
    }
  });
}

(window as any).testClick2Dial = (event, form: HTMLFormElement) => {
  event.preventDefault();
  event.stopPropagation();
  const phoneNumberField = (form.elements[0] as HTMLInputElement);
  if (event.submitter.value === 'sendSms') {
    if (!phoneNumberField.value) {
      phoneNumberField.focus();
    } else {
      const smsData = prompt('Enter SMS text (optional)');
      core.dialer.sendSms(phoneNumberField.value, smsData);
    }
  } else if (event.submitter.value === 'closeSms') {
    core.dialer.closeSms(phoneNumberField.value);
  } else {
    if (!phoneNumberField.value) {
      phoneNumberField.focus();
    } else {
      core.dialer.placeCall(phoneNumberField.value);
    }
  }
  // form.reset();
}
(window as any).loadIntegration = (event, integration) => {
  event.preventDefault();
  event.stopPropagation();
  config.integration = integration;
  reloadPlayground();
  return false;
}
(window as any).loadProvider = (event, provider) => {
  event.preventDefault();
  event.stopPropagation();
  config.provider = provider;
  reloadPlayground();
  return false;
}
(window as any).playgroundLog = (...args: any[]) => {
  const logContainer = document.getElementById('log');
  if (logContainer) {
    const pEl = document.createElement('p');
    const dateString = new Date().toLocaleTimeString('en-US', { hour12: false });
    let color = 'transparent';
    if (/Integration>/.test(args[0])) {
      color = 'salmon';
    } else if (/CommonCTI>/.test(args[0])) {
      color = 'yellowgreen';
    } else if (args[0] === 'InteractionEvent') {
      color = 'yellow';
    }
    const name = `<span style="background-color: ${color}; border-radius: 3px; border: 1px solid ${color === 'transparent' ? color : '#ccc'}; padding: 0 3px;">${args[0]}</span>`;
    pEl.innerHTML = '<i style="color: #ccc;">' + dateString + '</i>&nbsp;' + name + '&nbsp;';
    if (args[1]) {
      const codeEl = document.createElement('code');
      const msg = typeof(args[1]) === 'string' ? args[1] : JSON.stringify(args[1]);
      if (/Error:/.test(msg)) {
        codeEl.style.color = 'red';
      }
      codeEl.innerHTML = msg;
      pEl.appendChild(codeEl);
    }
    logContainer.appendChild(pEl);
    logContainer.scrollTop = logContainer.scrollHeight;
  }
}

export const setProvider = (provider: 'uc'|'cc', ccDomain?: string, ccAccount?: string) => {
  core.dialer.loadInterface(provider, ccDomain, ccAccount);
  if (provider === 'cc') {
    core.dialer.frame.style.width = '200px';
    core.dialer.frame.style.height = '400px';
  } else {
    core.dialer.frame.style.width = '260px';
    core.dialer.frame.style.height = '440px';
  }
}

export const setCountryCode = (countryCode: string) => {
  share.countryCode = countryCode;
  // if (share.worker) {
  //   share.worker.postMessage(
  //     { action: 'vLocalCountryCode', countryCode }
  //   );
  // }
  if (share.sendWorkerMessage) {
    share.sendWorkerMessage({ action: 'vLocalCountryCode', countryCode });
  }
  if (share.dialer) {
    console.log('!!! set country code for the dialer');
  }
}

const initDialer = (configuration) => {
  if (!dialerUI) {
    dialerUI = new DialerUI(configuration);
    share.placeCall = core.dialer.placeCall;
    share.sendSms = core.dialer.sendSms;
    share.closeSms = core.dialer.closeSms;
    window.postMessage({ scSysReq: true }, location.href);
  }
}

if (document.currentScript && /vonage\.dialer\./.test((document.currentScript as HTMLScriptElement).src)) {
  // when loaded as external script - by default initialize the UI
  const scriptDataset = document.currentScript ? document.currentScript.dataset : {};
  let provider: 'cc'|'uc' = /provider=cc/.test(location.search) ? 'cc' : 'uc';
  config.provider = provider;
  if (document.title === 'Common CTI Layer » Playground') {
    setTimeout(() => {
      const dialerContainer = document.getElementById('cti-playground-dialer-container');
      if (dialerContainer) {
        dialerContainer.style.width = (config.provider === 'uc') ? '260px' : '200px';
      }
    }, 200);
  }
  if (scriptDataset.provider === 'cc') {
    config.provider = 'cc';
    if (scriptDataset.ccDomain) {
      config.ccDomain = scriptDataset.ccDomain;
    }
    if (scriptDataset.ccAccount) {
      config.ccAccount = scriptDataset.ccAccount;
    }
  }
  if (['false', 'no', '0'].indexOf(scriptDataset.autoload) === -1) { // allow delayed load (when init is called)
    if (document.body) {
      initDialer(config);
    } else {
      const onLoad = () => {
        initDialer(config);
        if (window.removeEventListener) {
          window.removeEventListener('load', onLoad);
        } else {
          (window as any).detachEvent('onload', onLoad);
        }
      }
      if (window.addEventListener) {
        window.addEventListener('load', onLoad);
      } else {
        (window as any).attachEvent('onload', onLoad);
      }
    }
  }
}

export const init = (configuration: IDialerConfig, callback: (dialer: DialerApi) => void) => {
  if (!configuration.provider) {
    configuration.provider = config.provider;
  }
  if (configuration.provider === 'cc') {
    if (!configuration.ccDomain) {
      configuration.ccDomain = config.ccDomain;
    }
    if (!configuration.ccAccount) {
      configuration.ccAccount = config.ccAccount;
    }
  }
  const waitForDialer = () => {
    core.dialer.loadPromise.then(() => {
      if (typeof(callback) === 'function') {
        callback(new DialerApi(configuration));
      }
    });
  }
  if (document.body) {
    initDialer(configuration);
    waitForDialer();
  } else {
    const onLoad = () => {
      initDialer(configuration);
      waitForDialer();
      if (window.removeEventListener) {
        window.removeEventListener('load', onLoad);
      } else {
        (window as any).detachEvent('onload', onLoad);
      }
    }
    if (window.addEventListener) {
      window.addEventListener('load', onLoad);
    } else {
      (window as any).attachEvent('onload', onLoad);
    }
  }
};

export const placeCall = (phoneNumber: string, contact?: IContactableRef) => {
  if (core.dialer && typeof(core.dialer.placeCall) === 'function') {
    return core.dialer.placeCall(phoneNumber, contact);
  } else {
    console.error('VonageDialer is not ready! (Call init first).');
  }
  return core.dialer.placeCall(phoneNumber, contact);
}

export const sendSms = (phoneNumber: string, text?: string, contact?: IContactableRef) => {
  if (core.dialer && typeof(core.dialer.sendSms) === 'function') {
    return core.dialer.sendSms(phoneNumber, text, contact);
  } else {
    console.error('VonageDialer is not ready! (Call init first).');
  }
  return core.dialer.sendSms(phoneNumber, text, contact);
}

export const closeSms = (phoneNumber: string) => {
  if (core.dialer && typeof(core.dialer.closeSms) === 'function') {
    return core.dialer.closeSms(phoneNumber);
  } else {
    console.error('VonageDialer is not ready! (Call init first).');
  }
  return core.dialer.closeSms(phoneNumber);
}
